import Typography from '@eduzz/houston-ui/Typography';
import { makeStyles } from '@material-ui/core';
import ButtonBase from '@material-ui/core/ButtonBase';
import React from 'react';

const useStyles = makeStyles(() => ({
  buttonBase: {
    width: '100%',
    background: 'white',
    border: '1px solid #e8e8e8',
    padding: '28px',
    fontSize: 15,
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center',
    flexDirection: 'column',
    minHeight: '18vh',
    maxHeight: 106,
    color: '#192542',
    '&:hover': {
      boxShadow: '0 2px 2px 0 rgba(0,0,0,.18), 0 13px 24px 0 hsla(0,0%,62%,.1)',
      background: 'rgba(248, 248, 248, 0.6)',
    },

    '& h3': {
      marginBottom: 4,
      display: 'flex',
      alignItems: 'center',
      fontWeight: 600,
    },
  },
  buttonDisabled: {
    opacity: 0.4,
  },
}));

type ButtonProps = { name: string; title: string; subtitle: string; id: string; onClick?: () => void; logo?: string; icon?: React.ReactNode };

export const ButtonRedirect = ({ name, onClick, title, subtitle, logo, icon, id }: ButtonProps) => {
  const classes = useStyles();
  return (
    <ButtonBase id={id} onClick={onClick || null} classes={{ root: classes.buttonBase, disabled: classes.buttonDisabled }}>
      {icon && <div>{icon}</div>}
      {logo && <img width='35' src={logo} alt={`Plataforma ${name}`} />}
      <Typography size='sm' weight='semibold'>
        {title}
      </Typography>
      <Typography size='xs'>{subtitle}</Typography>
    </ButtonBase>
  );
};
